/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type SpendRuleActorUsage = {
  /**
   * Whether the rule expression currently matches this actor usage.
   */
  breached: boolean;
  /**
   * Actor display name, when known.
   */
  displayName?: string | undefined;
  /**
   * Actor email.
   */
  email: string;
  /**
   * Per-person budget in USD.
   */
  limitUsd: number;
  /**
   * Actor spend in USD within the current window.
   */
  spendUsd: number;
  /**
   * Spend as a percentage of the limit (may exceed 100).
   */
  usedPct: number;
  /**
   * Speakeasy user ID of the actor, when linked.
   */
  userId?: string | undefined;
};

/** @internal */
export const SpendRuleActorUsage$inboundSchema: z.ZodMiniType<
  SpendRuleActorUsage,
  unknown
> = z.pipe(
  z.object({
    breached: z.boolean(),
    display_name: z.optional(z.string()),
    email: z.string(),
    limit_usd: z.number(),
    spend_usd: z.number(),
    used_pct: z.number(),
    user_id: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "display_name": "displayName",
      "limit_usd": "limitUsd",
      "spend_usd": "spendUsd",
      "used_pct": "usedPct",
      "user_id": "userId",
    });
  }),
);

export function spendRuleActorUsageFromJSON(
  jsonString: string,
): SafeParseResult<SpendRuleActorUsage, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SpendRuleActorUsage$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SpendRuleActorUsage' from JSON`,
  );
}
